import {Backdrop, CircularProgress, Theme} from "@mui/material";

const BackdropSpinner = () => {
    return (
        <Backdrop sx={{
            zIndex: (theme: Theme) => theme.zIndex.tooltip + 1
        }} open={true}>
            <CircularProgress color="primary"/>
        </Backdrop>
    )
}
export default BackdropSpinner
